module.exports = __webpack_public_path__ + "img/airplane-logo.896cb0ac.svg";